<template>
  <div class="mall-address-manage">
    <div class="page">
      <MallHeader @back-click="goBack">
        <div slot="right"></div>
      </MallHeader>

      <div v-if="isLoaded" class="mall-address-manage__content">
        <span class="mall-address-manage__heading">배송지 관리</span>

        <!-- 등록된 배송지 -->
        <div v-if="address" class="mall-address-manage__address">
          <div class="mall-address-manage__address-icon">
            <img src="@/assets/mall/icn_home_color_small.svg" alt="" />
          </div>
          <div class="mall-address-manage__address-body">
            <div class="mall-address-manage__address-text">
              <span class="mall-address-manage__recipient">{{ address.recipient }}</span>
              <span class="mall-address-manage__line">{{ address.line }}</span>
              <span v-if="address.message" class="mall-address-manage__message">{{ address.message }}</span>
            </div>
            <MallButton
              class="mall-address-manage__edit-button"
              :label="'수정'"
              :type="'secondary'"
              :size="'sm'"
              @click="goRegister"
            />
          </div>
        </div>

        <!-- 등록된 배송지가 없을 때 -->
        <div v-else class="mall-address-manage__empty">
          <div class="mall-address-manage__empty-text">
            <img src="@/assets/mall/icn_file_text_color.svg" alt="" />
            <span>배송지 정보가 없어요</span>
          </div>
          <MallButton
            class="mall-address-manage__empty-button"
            :label="'배송지 등록하기'"
            :type="'secondary'"
            :size="'md'"
            @click="goRegister"
          />
        </div>
      </div>

      <MallToast
        v-if="toast"
        :key="toast.key"
        :title="toast.title"
        :message="toast.message"
        @close="toast = null"
      />
    </div>
  </div>
</template>

<script>
import mall from '@/utilities/mall.js'
import MallButton from '@/components/new/atoms/MallButton.vue'
import MallHeader from '@/components/new/molecules/MallHeader.vue'
import MallToast from '@/components/new/molecules/MallToast.vue'

// 배송지 관리 (프로필 하나에 배송지 하나 - 기존 /address 화면과 별개)
export default {
  name: 'MallAddressManage',
  components: {
    MallButton,
    MallHeader,
    MallToast,
  },
  data() {
    return {
      profileId: Number(this.$route.query.profileId) || null,
      // { recipient(받는 분 = address_nickname), line(주소 + 상세 주소), message(배송 메시지) }, 없으면 null
      address: null,
      isLoaded: false,
      toast: null,
    }
  },
  mounted() {
    ChannelIO('shutdown')
    var token = mall.getAccessToken()
    if (!token) {
      mall.goLogin(this.$router)
      return
    }
    mall.fetchProfile(this.$store, this.profileId, token)
      .then((item) => {
        var profile = item ? item.profile : null
        this.address = profile && profile.address ? {
          recipient: profile.address_nickname || '',
          line: [profile.address, profile.detail_address].filter((text) => !!text).join(' '),
          message: profile.address_description || '',
        } : null
        this.isLoaded = true
      })
      .catch((err) => {
        if (mall.isAuthError(err)) {
          mall.goLogin(this.$router)
          return
        }
        this.toast = { key: Date.now(), title: '배송지 정보를 불러오지 못했어요.', message: mall.errorMessage(err) }
      })
  },
  methods: {
    // 구매하기에서 들어왔으면 구매하기로, 아니면 몰 홈으로
    goBack() {
      mall.goBack(this.$router, this.$route, { path: '/mall/shop', query: { profileId: this.profileId } })
    },
    // 입력 화면에서 돌아올 때 이 화면의 returnTo가 유지되도록 현재 주소를 전달
    goRegister() {
      this.$router.push({ path: '/mall/address/register', query: { profileId: this.profileId, returnTo: this.$route.fullPath } })
    },
  },
}
</script>

<style scoped>
  .mall-address-manage {
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: flex-start;
  }
  .page {
    width: 100%;
    min-height: 100vh;
    background: #FFF;
  }
  .mall-address-manage__content {
    display: flex;
    padding: 4px 16px 32px 16px;
    flex-direction: column;
    gap: 48px;
  }
  .mall-address-manage__heading {
    padding-left: 4px;
    color: var(--color-text-main);
    font-family: Pretendard;
    font-size: var(--font-size-2xl);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-tight);
  }
  /* Figma 여백 17px / 13px(테두리 1px 포함) + 목록 항목 여백 2px */
  .mall-address-manage__address {
    display: flex;
    padding: 18px 14px;
    align-items: flex-start;
    gap: 12px;
    border: 1px solid #E5E8EB;
    border-radius: 12px;
    background: #F9FAFB;
  }
  /* 24px 영역 안에 21x18 그래픽 (Figma 기준 위치) */
  .mall-address-manage__address-icon {
    position: relative;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    overflow: hidden;
  }
  .mall-address-manage__address-icon img {
    position: absolute;
    top: 3px;
    left: 1.5px;
    display: block;
  }
  .mall-address-manage__address-body {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .mall-address-manage__address-text {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 4px;
    font-family: Pretendard;
    font-weight: var(--font-weight-medium);
    word-break: keep-all;
    overflow-wrap: anywhere;
  }
  .mall-address-manage__recipient {
    color: var(--color-text-main);
    font-size: var(--font-size-md);
    line-height: var(--line-height-normal);
  }
  .mall-address-manage__line {
    color: #4E5968;
    font-size: var(--font-size-sm);
    line-height: var(--line-height-normal);
  }
  .mall-address-manage__message {
    color: #8B95A1;
    font-size: var(--font-size-sm);
    line-height: var(--line-height-normal);
  }
  .mall-address-manage__edit-button {
    width: 60px;
  }
  /* Figma 안쪽 테두리 기준 여백 32px / 16px (테두리 1px 포함) */
  .mall-address-manage__empty {
    display: flex;
    padding: 31px 15px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    border: 1px solid #F2F4F6;
    border-radius: 12px;
    background: #FFF;
  }
  .mall-address-manage__empty-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: #6B7684;
    font-family: Pretendard;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-normal);
  }
  .mall-address-manage__empty-text img {
    display: block;
  }
  /* MallButton 기본 flex: 1 이 세로 방향에서 높이를 줄이지 않도록 (선택자를 한 단계 더 구체적으로) */
  .mall-address-manage__empty .mall-address-manage__empty-button {
    flex: none;
    width: 240px;
  }
  @media (min-width: 600px) {
    .page {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/MallAddressManage.vue